import * as yup from "yup";
import { DEFAULT_MESSAGES } from "../defaultMessages";

export const createAreaSchema = yup.object({
  nombre: yup.string().required(DEFAULT_MESSAGES.REQUIRED),

  descripcion: yup.string().optional(),

  nivel_id: yup.number().required(DEFAULT_MESSAGES.REQUIRED),
});
